var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "7px",
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "manage-cc-card/add-empty",
    transform: "translate(-510.000000, -187.000000)",
    fill: "#444B68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(42.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.000000, 30.300000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-down",
    transform: "translate(467.000000, 17.200000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(6.500000, 4.000000) rotate(-270.000000) translate(-6.500000, -4.000000) ",
    points: "3 -0.6 4.32432432 -2 10 4 4.32432432 10 3 8.6 7.35135135 4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.bdedae12de96bb53d606fbd693d2cb48.svg";
export { ForwardRef as ReactComponent };